import { useDictationAudio } from './useDictationAudio'

export function useAiAskBarDictationModel({ isDictating }) {
  const { levels, micError, finalizeSession, minBarPx, maxBarPx } = useDictationAudio({
    isActive: isDictating,
  })

  return { levels, micError, finalizeSession, minBarPx, maxBarPx }
}
